import { render, staticRenderFns } from "./OptionButtons.vue?vue&type=template&id=0aa093c4"
import script from "./OptionButtons.vue?vue&type=script&lang=js"
export * from "./OptionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports